import { useCallback } from "react";

import { error, success } from "constants";
import { useToaster } from "hooks";
import { getCall, getCall_v2 } from "services";

const downloadUrl = "/oms/shipment/documents";
const jomsDownloadUrl = "/joms/api/internal/v1/shipment/download";

const useDownloadInvoiceFile = () => {
  const triggerToaster = useToaster();

  const downloadFile = useCallback((res, fileName) => {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(res);
    link.download = fileName;
    link.click();
  }, []);

  const triggerDownloadInvoice = useCallback(
    async (file, fileType, shipmentId, invoiceNumber) => {
      const params = {
        shipmentId,
        fileType,
        fileId: file?.generatedId,
        invoiceNumber,
      };

      const res = await getCall(
        downloadUrl,
        params,
        (err) =>
          triggerToaster(
            err?.detail || `Downloading ${invoiceNumber} invoice`,
            error,
          ),
        "blob",
      );

      if (res) {
        downloadFile(res, file.originalName);
        triggerToaster(`Downloading ${invoiceNumber} invoice`, success);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [triggerToaster],
  );

  const triggerDownloadInvoiceViaJoms = useCallback(
    async (file, fileType, shipmentNumber, invoiceNumber) => {
      const params = {
        shipmentNumber,
        type: fileType,
        fileId: file?.generatedId,
        invoiceNumber,
      };
      const { data } = await getCall_v2(jomsDownloadUrl, params, "blob");

      if (data) {
        downloadFile(data, file.originalName);
        triggerToaster(`Downloading ${invoiceNumber} invoice`, success);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [triggerToaster],
  );

  return { triggerDownloadInvoice, triggerDownloadInvoiceViaJoms };
};

export default useDownloadInvoiceFile;